import { cn } from "@/utils/cn";

export default function LoadingSpiner({
  msg,
  className,
}: {
  msg?: string;
  className?: string;
}) {
  const arr = [...Array(12)];
  return (
    <div
      className={cn(
        "items-center w-full    flex justify-center relative",
        className
      )}
    >
      <div className="relative size-4">
        {arr.map((_, idx) => (
          <span
            className={`bg-foreground absolute w-[3px] origin-bottom  h-[9px] rounded-md animate-opacity-infinity`}
            style={{
              animationDelay: `${idx * 0.1}s`,
              transform: `rotate(${idx * 30}deg) translateY(-80%)`,
            }}
            key={idx}
          />
        ))}
      </div>
      {msg ? (
        <div className="ml-5 text-accent-foreground  text-base font-pretendard">
          {msg}
        </div>
      ) : undefined}
    </div>
  );
}
